import { render } from "./routerButtonBlock.vue?vue&type=template&id=63dc7cbf&ts=true"
import script from "./routerButtonBlock.vue?vue&type=script&lang=ts"
export * from "./routerButtonBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__